<template>
  <div>
    <navBar></navBar>
    <van-row class="main">
      <div v-if="activeinfo?.eventInfo?.eventTypes == 'online_video'">
        <van-col :span="24" class="status" v-if="activeinfo?.statuss == 'normal'">
          <img src="@/assets/images/err.png" alt="" />
          <p>
            报名成功!待审核
          </p>
          <p class="title_tip">审核通过后，将为您发放签到码</p>
        </van-col>
        <van-col :span="24" class="status" v-else>
          <img src="@/assets/images/success.png" alt="" />
          <p>报名成功!请准时参加</p>
        </van-col>
      </div>
      <div v-else-if="activeinfo?.eventInfo?.eventTypes == 'online'">
        <van-col :span="24" class="status" v-if="activeinfo?.statuss == 'normal'">
          <img src="@/assets/images/err.png" alt="" />
          <p>
            报名成功!待审核
          </p>
          <!-- <p class="title_tip">审核通过后，将为您发放签到码</p> -->
        </van-col>
        <van-col :span="24" class="status" v-else>
          <img src="@/assets/images/success.png" alt="" />
          <p>报名成功!请准时参加</p>
        </van-col>
      </div>
      <div v-else>
        <van-col :span="24" class="status" v-if="activeinfo?.statuss == 'normal' || activeinfo?.statuss == 'success'
        ">
          <img src="@/assets/images/err.png" alt="" />
          <p>
            报名成功！待{{ activeinfo?.statuss == "normal" ? "审核" : "签到" }}
          </p>
        </van-col>
        <van-col :span="24" class="status" v-else>
          <img src="@/assets/images/success.png" alt="" />
          <p>已签到</p>
        </van-col>
      </div>
      <div id="signinfo" ref="maincount" style="overflow: hidden;width: 100%;">
        <van-col :span="24" class="title" @click="toEventInfo()">
          <img crossorigin=“anonymous” :src="activeinfo?.eventInfo?.thumb + '?i=' + new Date().getTime()" alt="" />
          <p>{{ activeinfo?.eventInfo?.title }}</p>
        </van-col>
        <van-col :span="24" class="qcode" v-if="activeinfo?.statuss != 'normal'">
          <div v-if="activeinfo?.eventInfo?.eventTypes == 'online_video'">
            <p>{{ activeinfo?.eventInfo?.meetingVideoName }}</p>
            <img crossorigin=“anonymous” :src="activeinfo?.eventInfo?.meetingVideoUrl + '?i=' + new Date().getTime()"
              alt="没有签到码" ref="toast" />
          </div>
          <div v-else-if="activeinfo?.eventInfo.eventTypes == 'online'" class="info" style="padding-top: 0; padding-bottom: 0; font-weight: normal;">
            <!-- <p></p> -->
            <!-- <img crossorigin=“anonymous” :src="activeinfo?.qrcode + '?i=' + new Date().getTime()" alt="没有签到码"
              ref="toast" /> -->
              <p>会议链接：{{ activeinfo?.eventInfo?.meetingLink }}</p>
              <p>会议号：{{ activeinfo?.eventInfo?.meetingNo }}</p>
          </div>
          <div v-else>
            <p>请向工作人员出示二维码签到</p>
            <img crossorigin=“anonymous” :src="activeinfo?.qrcode + '?i=' + new Date().getTime()" alt="没有签到码"
              ref="toast" />
          </div>
        </van-col>
        <van-col :span="24" class="info">
          <p>活动时间：{{ activeinfo?.eventInfo?.startTime }}</p>
          <div class="address">
            <p>活动地点：</p>
            <div>{{ activeinfo?.eventInfo?.location }}</div>
          </div>
          <p>联系人：{{ activeinfo?.eventInfo?.contactPerson }}</p>
          <p>联系电话：{{ activeinfo?.eventInfo?.phone }}</p>
          <p>联系邮箱：{{ activeinfo?.eventInfo?.email }}</p>
        </van-col>
      </div>
    </van-row>
    <div class="btns" v-if="activeinfo?.statuss == 'success'">
      <van-button round type="info" @click="download">保存到手机</van-button>
    </div>
    <van-overlay :show="isshow" z-index="999" @click="isshow = false">
      <div class="showdowncode">

      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Notify } from "vant";
import { Toast } from "vant";
import navBar from "@/components/navBar.vue";
import { getSignData } from "@/api/home/index";
import html2canvas from "html2canvas"
export default {
  components: {
    navBar,
  },
  data() {
    return {
      id: null,
      activeinfo: null,
      isshow: false,
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getavtive();
  },
  methods: {
    getavtive() {
      getSignData(this.id)
        .then((res) => {
          // console.log(res);
          this.activeinfo = res;
        })
        .catch((e) => {
          Notify({ type: "warning", message: e.message });
        });
    },
    toEventInfo() {
      this.$router.push({
        path: "/activeinfo",
        query: {
          id: this.activeinfo.eventId,
        },
      });
    },
    downcode() {
      // 生成二维码
      let qrcode = this.activeinfo.qrcode;
      let a = document.createElement("a");
      a.href = qrcode;
      a.download = "二维码";
      a.click();
    },
    DPR() { // 获取设备dpi
      if (window.devicePixelRatio && window.devicePixelRatio > 1) {
        return window.devicePixelRatio;
      }
      return 1;
    },
    download() {
      let inviteBox = document.getElementById("signinfo")
      let width = inviteBox.offsetWidth;
      let height = inviteBox.offsetHeight;
      const scaleBy = this.DPR();
      let canvas = document.createElement("canvas")
      canvas.width = width * scaleBy // 最终图片宽度280px的2倍，以px为单位
      canvas.height = height * scaleBy  // 最终图片高度315px的2倍，以px为单位
      canvas.style.width = width + 'px'   // 最终图片宽度280px的2倍，以px为单位
      canvas.style.height = height + 'px'  // 最终图片高度315px的2倍，以px为单位
      let opts = {
        canvas: canvas,                       // 将自定义canvas作为配置项
        useCORS: true,                        // 允许图片跨域
        // allowTaint: true,
        // height: this.$refs.maincount.offsetHeight, // 修复截图不完整问题
        scale: 1,
        width: width,
        height: height,
        dpi: 300,
        background: "#fff",
      }
      // 获取画笔
      const context = canvas.getContext('2d');
      // 将所有绘制内容放大像素比倍
      context.scale(scaleBy, scaleBy);
      html2canvas(inviteBox, opts).then((canvas) => {
        // console.log(canvas)
        /* 此处的base64ImgSrc就是得到的img的base64字符串，直接在页面上显示即可 */
        let base64ImgSrc = canvas.toDataURL("image/png")
        // console.log(base64ImgSrc)
        let img = document.createElement("img")
        img.src = base64ImgSrc
        img.style.width = '100%'
        // document.body.appendChild(img)
        // 找到showdowncode的元素把图片插入进去
        let showdowncode = document.querySelector(".showdowncode")
        showdowncode.innerHTML = "";
        showdowncode.appendChild(img)
        this.isshow = true
        Toast.success('请长按图片进行保存');
        // document.body.appendChild(img)
        // document.body.appendChild(canvas)
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.main {
  margin-top: 46px;

  .van-col {
    border-bottom: 1px solid #f0eeee;
  }

  .van-col:last-child {
    border-bottom: none;
  }

  .status {
    padding: 20px 0;
    font-size: 16px;

    p {
      margin-top: 10px;
    }

    img {
      width: 38px;
      height: 38px;
    }
  }

  .title {
    display: flex;
    align-items: center;
    padding: 15px 22px;

    img {
      width: 110px;
      height: 58px;
      margin-right: 12px;
    }

    p {
      font-size: 14px;
      font-weight: bold;
      text-align: left;
    }
  }

  .qcode {
    padding: 22px 0;
    font-size: 16px;
    font-weight: bold;

    img {
      width: 150px;
      height: 150px;
      margin-top: 20px;
    }
  }

  .info {
    padding: 20px;
    font-size: 14px;
    text-align: left;
    line-height: 30px;

    .address {
      display: flex;

      // p{
      //   width: 70px;
      // }
      div {
        width: calc(100% - 70px);
      }
    }
  }
}

.btns {
  padding: 0 20px 30px;

  .van-button {
    background: #2553e2;
    width: 100%;
  }
}

.showdowncode {
  height: 100%;
  display: flex;
  align-items: center;

  img {
    width: 100%;
    height: 100%;
  }
}

.title_tip {
  font-size: 12px;
}
</style>